import { mapActions, mapMutations, mapStates, mapGetters } from './../baseModule'
import CouchdbClass from 'src/services/CouchdbClass'
import { dashboardCounter } from 'src/services/DashboardCounter.js'

const moment = require('moment')
const collection = 'lamps'
const singleName = 'lamp'
const pluralName = 'lamps'

const Couchdb = new CouchdbClass({connection: 'default', collection: collection})
const CouchdbConfig = new CouchdbClass({ connection: 'config', collection: 'projects' })

const model = {
  type: '',
  room: '',
  usageHoursPerDay: 8,
  power: 0,
  rushHour: false
}
const validations = {
  type: { required: true },
  room: { required: true },
  usageHoursPerDay: {
    required: true,
    min: 1,
    max: 24
  },
  power: { required: true }
}
const options = {
  power: [
    {
      value: 11,
      label: '11W'
    },
    {
      value: 14,
      label: '14W'
    },
    {
      value: 15,
      label: '15W'
    },
    {
      value: 18,
      label: '18W'
    },
    {
      value: 20,
      label: '20W'
    },
    {
      value: 25,
      label: '25W'
    },
    {
      value: 30,
      label: '30W'
    },
    {
      value: 34,
      label: '34W'
    },
    {
      value: 40,
      label: '40W'
    },
    {
      value: 60,
      label: '60W'
    },
    {
      value: 70,
      label: '70W'
    },
    {
      value: 80,
      label: '80W'
    },
    {
      value: 100,
      label: '100W'
    },
    {
      value: 160,
      label: '160W'
    }
  ],
  type: [
    {
      value: 'Incandescente',
      label: 'Incandescente'
    },
    {
      value: 'Fluorescente',
      label: 'Fluorescente'
    }
  ],
  room: [
    {
      value: 'Banheiro',
      label: 'Banheiro'
    },
    {
      value: 'Cozinha',
      label: 'Cozinha'
    },
    {
      value: 'Lavanderia',
      label: 'Lavanderia'
    },
    {
      value: 'Quarto',
      label: 'Quarto'
    },
    {
      value: 'Sala',
      label: 'Sala'
    },
    {
      value: 'Outros',
      label: 'Outros'
    }
  ]
}
let getters = {...mapGetters()}
getters[singleName] = state => state.one
getters[pluralName] = state => {
  let lamps = []
  state.all.map(one => {
    for (let i in one['items']) {
      let o = one['items'][i]
      o.userId = one['userId']
      lamps.push(o)
    }
  })
  return lamps
}
getters = Object.assign(getters, {
  loading: state => state.loading,
  validations: state => state.validations,
  /**
   * Quantidade de lâmpadas trocadas
   */
  count: state => state.all.length,
  countLamps: state => state.all.reduce((accumulate, current) => {
    accumulate += current.hasOwnProperty('items') ? current.items.length : 0
    return accumulate
  }, 0),
  /**
   * Quantidade de trocas efetuadas
   */
  countOperations: state => {
    return state.all.length
  },
  lampsAll: state => state.all,
  options: state => state.options,
  lampsTmp: state => state.lampsTmp,
  allLamps: state => state.allLamps
})
export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0,
    options: options,
    lampsTmp: [],
    allLamps: []
  },
  mutations: {
    ...mapMutations(),
    setLampsTmp: (state, payload) => {
      state.lampsTmp = payload
    }
  },
  actions: {
    ...mapActions(collection, model),

    setCurrentLampsTmp ({ commit }, payload) {
      commit('setLampsTmp', payload)
    },
    async fetchLampsByCustomerId (context, payload) {
      let configProject = await CouchdbConfig.get()
      configProject = configProject[0]
      let lampsStartOfValidPeriod = null
      if (configProject.lamps.hasSeason && configProject.lamps.seasonRange > 0) {
        lampsStartOfValidPeriod = moment().subtract(configProject.lamps.seasonRange, 'months').toISOString()
      } else if (configProject.lamps.hasSeason && configProject.lamps.seasonRange === '0') {
        let dateStart = new Date()
        dateStart.setDate(1)
        dateStart.setMonth(0)
        dateStart.setHours(0)
        dateStart.setMinutes(0)
        dateStart.setSeconds(0)
        lampsStartOfValidPeriod = dateStart
      }
      context.commit('changeLoading', true)
      return Couchdb
        .select(['_id', 'customer', 'items', 'userId', 'eventId', 'createdAt'])
        .where('customer.id', payload)
        .whereGreatThen('createdAt', lampsStartOfValidPeriod)
        .get()
        .then(res => {
          context.commit('setAll', res)
          context.commit('changeLoading', false)
          return res
        })
        .catch(err => {
          context.commit('changeLoading', false)
          return err
        })
    },

    dashboardLampsByFilter (context, { eventsId }) {
      context.commit('changeLoading', true)
      return dashboardCounter('lamps', eventsId)
        .then(result => {
          context.commit('SET_DASHBOARD_COUNTER', result)
          context.commit('changeLoading', false)
          return result
        })
        .catch(err => {
          console.log(err)
          context.commit('changeLoading', false)
          return err
        })
    },

    uploadFileLamp (context, { id, mimeType, name, attachment }) {
      return Couchdb.connection('docs')
        .where('referenceId', id)
        .get()
        .then(async res => {
          let doc = false
          if (res.length === 0) {
            doc = await Couchdb.connection('docs')
              .insert({ referenceId: id, collection: 'lamps', database: 'trg_admin' })
          }

          await Couchdb.connection('docs')
            .insertAttachment(doc.id, {
              mimeType: mimeType,
              attachmentName: name,
              attachment: attachment
            })
        })
    },
    countLampsByEvent (context, eventId) {
      return Couchdb.view('count-lamps-by-event', 'count-lamps-by-event', eventId, { group: true, reduce: true })
        .then(result => {
          return result && result.hasOwnProperty('rows') && result.rows.length > 0 ? result.rows[0].value : 0
        })
    }
  },
  getters: {
    ...getters,
    lampsByUser: state => state.one.hasOwnProperty('items') ? state.one.items.length : 0
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/lamps.js